<template>
  <v-app id="login">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3" style="border-radius: 20px">
              <v-card-text>
                <div class="">
                  <img  class="align-left" src="static/logo.png" style="width: 50%" >
                  <h1 class="flex my-4 primary--text layout column align-center">Sign in</h1>
                </div>                
                <v-form>
                  <v-text-field append-icon="person" name="login" label="Login" type="text" v-model="email"></v-text-field>
                  <v-text-field append-icon="lock" name="password" label="Password" id="password" type="password" v-model="password"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn block color="primary" @click="login" :loading="loading">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
    import Notifications from 'vue-notification'
    import Vue           from 'vue'
    Vue.use(Notifications)
  /* eslint-disable */
  export default {
      components: {
          Notifications
      },
  data: () => ({

    loading: false,
      email: '',
      password: ''
  }),
    beforeCreate: function () {
        if (this.$session.exists()) {
            this.$router.push('/database/DB/Ar')
        }
        else { this.$router.push('/login')}
    },
  methods: {
    login () {
      this.loading = true;
        const {email, password} = this;
        var formData = new FormData();
        formData.append('email', email);
        formData.append('password', password);
        this.$http.post('https://acg-generations.com/acg_laravel/public/loginAdmin',formData,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
            var data = response.bodyText
            var obj = JSON.parse(data);
            if(obj.error==="false"){
                this.$router.push(data.redirect ? data.redirect : '/database/DB/Ar')
                this.$session.start()
                this.$session.set('email', obj.email)
                this.loading = false;

            }
            else {
                this.loading = false;

            }
        }, response => {

            setTimeout(() => {
                this.loading = false;
                this.username = "";
                this.password = "";
            }, 3000);


        });
    }
  }

};
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    background-image: url("static/discover_word/back.jpg");
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue